/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from 'react'
import { BulletList } from 'react-content-loader'

import '../ShopList/list.scss'

import { useNavigate } from 'react-router-dom'

export default function index(data) {
  const [jobs, setJobs] = useState([])
  const navigate = useNavigate()

  useEffect(() => {
    setJobs(data.data)
  }, [data])

  return (
    <>
      <table className='table'>
        <thead>
          <tr>
            <th>نام و نام خانوادگی</th>
            <th>شماره موبایل</th>
            <th>تاریخ رزرو</th>
            <th>وضعیت</th>
            <th>عملیات</th>
          </tr>
        </thead>
        <tbody>
          {jobs ? jobs.map(item => 
              <tr key={item._id}>
                <td>{item.name}</td>
                <td>{item.phoneNumber}</td>
                <td>{item.reserveDate}</td>
                <td style={item.status ? { color: '#198524' } : { color: '#fd3a50' }}>{item.status ? 'بررسی شده' : 'بررسی نشده'}</td>
                <td>
                  <button onClick={() => navigate(`/im/reservation/detail/${item._id}`)}>مشاهده</button>
                </td>
              </tr>) : <tr><td colSpan="5"><BulletList rtl style={{ width: '30%', rowspan: '5' }}/></td></tr>}
        </tbody>
      </table>
    </>
  );
}
